import Img_hk from './hk.png'
import Img_th from './th.png'
import Img_vi from './vi.png'
import Img_en from './en.png'
import Img_id from './id.png'

export default {
  hk: Img_hk,
  tw: Img_hk,
  th: Img_th,
  vi: Img_vi,
  en: Img_en,
  sg: Img_en,
  my: Img_en,
  ph: Img_en,
  id: Img_id,
}
